<template>
  <v-container>
    <v-row justify="center">
      <v-col lg="8">
        <ResourceTableWidget :isLoading="isLoading" />
      </v-col>
    </v-row>
  </v-container>
</template>
<style lang="sass" scoped></style>
<script>
// @ is an alias to /src
import ResourceTableWidget from "@/components/ResourceTableWidget.vue";

export default {
  name: "ResourceTable",
  components: {
    ResourceTableWidget
  },
  data: () => ({
    isLoading: false
  }),
  async mounted() {}
};
</script>
